import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Purchase } from '~/features/purchase/types/purchase.type';

/**
 * 구매 상세 조회
 * @description 특정 구매 내역의 상세 정보를 조회합니다
 * @endpoint GET /admin/purchases/{id}
 * @param id - 구매 ID
 * @returns 구매 상세 정보
 */
export function getPurchaseApi(id: number) {
  return axiosInstance.get<ApiResponse<Purchase>>(`/admin/purchases/${id}`);
}
